import React from "react";

export const CloseIcon = () => (
  <svg
    width="14"
    height="14"
    fill="current"
    viewBox="0 0 14 14"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M13.3 0.710001C12.91 0.320001 12.28 0.320001 11.89 0.710001L6.99997 5.59L2.10997 0.700001C1.71997 0.310001 1.08997 0.310001 0.699971 0.700001C0.309971 1.09 0.309971 1.72 0.699971 2.11L5.58997 7L0.699971 11.89C0.309971 12.28 0.309971 12.91 0.699971 13.3C1.08997 13.69 1.71997 13.69 2.10997 13.3L6.99997 8.41L11.89 13.3C12.28 13.69 12.91 13.69 13.3 13.3C13.69 12.91 13.69 12.28 13.3 11.89L8.40997 7L13.3 2.11C13.68 1.73 13.68 1.09 13.3 0.710001V0.710001Z" />
  </svg>
);

export const SearchIcon = () => (
  <svg
    width="18"
    height="18"
    fill="current"
    viewBox="0 0 18 18"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.1867 11.4713H12.9767L17.2167 15.7313C17.6267 16.1413 17.6267 16.8113 17.2167 17.2213C16.8067 17.6313 16.1367 17.6313 15.7267 17.2213L11.4767 12.9713V12.1813L11.2067 11.9013C9.8067 13.1013 7.8967 13.7213 5.8667 13.3813C3.0867 12.9113 0.8667 10.5913 0.5267 7.79133C0.00669983 3.56133 3.5667 0.00132874 7.7967 0.521329C10.5967 0.861329 12.9167 3.08133 13.3867 5.86133C13.7267 7.89133 13.1067 9.80133 11.9067 11.2013L12.1867 11.4713ZM2.4767 6.97133C2.4767 9.46133 4.4867 11.4713 6.9767 11.4713C9.4667 11.4713 11.4767 9.46133 11.4767 6.97133C11.4767 4.48133 9.4667 2.47133 6.9767 2.47133C4.4867 2.47133 2.4767 4.48133 2.4767 6.97133Z"
    />
  </svg>
);

export const ArrowIcon = () => (
  <svg
    width="9"
    height="15"
    viewBox="0 0 9 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 11.4725L4.96167 6.5L0 1.5275L1.5275 0L8.0275 6.5L1.5275 13L0 11.4725Z"
      fill="currentColor"
    />
  </svg>
);

export const TV = () => (
  <svg
    width="100"
    height="100"
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M49.9988 92.6314C73.5437 92.6314 92.6303 73.7804 92.6303 50.5262C92.6303 27.2719 73.5437 8.4209 49.9988 8.4209C26.4538 8.4209 7.36719 27.2719 7.36719 50.5262C7.36719 73.7804 26.4538 92.6314 49.9988 92.6314ZM49.9988 89.5877C28.156 89.5877 10.449 72.0993 10.449 50.5262C10.449 28.953 28.156 11.4647 49.9988 11.4647C71.8415 11.4647 89.5485 28.953 89.5485 50.5262C89.5485 72.0993 71.8415 89.5877 49.9988 89.5877Z"
      fill="black"
    />
    <rect
      x="25"
      y="34"
      width="50"
      height="28.5714"
      stroke="black"
      strokeWidth="3"
      strokeLinejoin="round"
    />
    <rect
      x="31.8164"
      y="61.3535"
      width="36.3636"
      height="5.68182"
      rx="1"
      fill="black"
    />
  </svg>
);

export const Link = () => (
  <svg
    width="100"
    height="100"
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M49.9988 92.6314C73.5437 92.6314 92.6303 73.7804 92.6303 50.5262C92.6303 27.2719 73.5437 8.4209 49.9988 8.4209C26.4538 8.4209 7.36719 27.2719 7.36719 50.5262C7.36719 73.7804 26.4538 92.6314 49.9988 92.6314ZM49.9988 89.5877C28.156 89.5877 10.449 72.0993 10.449 50.5262C10.449 28.953 28.156 11.4647 49.9988 11.4647C71.8415 11.4647 89.5485 28.953 89.5485 50.5262C89.5485 72.0993 71.8415 89.5877 49.9988 89.5877Z"
      fill="black"
    />
    <path
      d="M45.4997 36.4996V33.4999C45.4997 32.6712 44.8285 32 43.9999 32C43.1717 32 42.5 32.6712 42.5 33.4999V36.4996C42.5 37.3283 43.1717 37.9995 43.9999 37.9995C44.8285 37.9995 45.4997 37.3283 45.4997 36.4996Z"
      fill="black"
    />
    <path
      d="M33.4999 45.4997H36.4996C37.3283 45.4997 37.9995 44.8285 37.9995 43.9999C37.9995 43.1717 37.3283 42.5 36.4996 42.5H33.4999C32.6712 42.5 32 43.1717 32 43.9999C32 44.8285 32.6712 45.4997 33.4999 45.4997Z"
      fill="black"
    />
    <path
      d="M39.0578 36.9416L37.5579 35.4418C36.9625 34.9322 36.0753 34.9662 35.5212 35.5203C34.9672 36.0743 34.9332 36.9616 35.4428 37.5569L36.9426 39.0568C37.538 39.5663 38.4247 39.5318 38.9787 38.9778C39.5328 38.4237 39.5673 37.537 39.0577 36.9417L39.0578 36.9416Z"
      fill="black"
    />
    <path
      d="M55.9998 67.9995C56.3974 67.9995 56.7793 67.8415 57.0603 67.5606C57.3417 67.2791 57.4997 66.8977 57.4997 66.4996V63.4999C57.4997 62.6712 56.828 62 55.9999 62C55.1712 62 54.5 62.6712 54.5 63.4999V66.4996C54.5 66.8977 54.658 67.2791 54.9389 67.5606C55.2204 67.8415 55.6018 67.9995 55.9999 67.9995H55.9998Z"
      fill="black"
    />
    <path
      d="M67.9995 55.9994C67.9995 55.6013 67.8415 55.2199 67.5606 54.9384C67.2791 54.6575 66.8977 54.4995 66.4996 54.4995H63.4999C62.6712 54.4995 62 55.1707 62 55.9994C62 56.8275 62.6712 57.4992 63.4999 57.4992H66.4996C66.8977 57.4992 67.2791 57.3412 67.5606 57.0598C67.8415 56.7789 67.9995 56.397 67.9995 55.9993V55.9994Z"
      fill="black"
    />
    <path
      d="M62.4424 64.5575C63.0377 65.0671 63.925 65.0331 64.479 64.479C65.0331 63.925 65.0671 63.0377 64.5575 62.4424L63.0576 60.9425C62.4623 60.433 61.5756 60.4675 61.0215 61.0215C60.4675 61.5755 60.433 62.4623 60.9425 63.0576L62.4424 64.5575Z"
      fill="black"
    />
    <path
      d="M33.5 57.5746C33.5037 59.9408 34.4453 62.2082 36.1184 63.8813C37.7915 65.5543 40.0589 66.496 42.4251 66.4997C44.793 66.507 47.0651 65.5643 48.7324 63.8824L53.3822 59.2325H53.3827C55.0558 57.56 55.9965 55.291 55.9965 52.9247C55.9965 50.559 55.0559 48.2896 53.3827 46.617C53.1076 46.3125 52.7194 46.1336 52.3087 46.1231C51.898 46.1121 51.5015 46.2701 51.2106 46.5599C50.9197 46.8498 50.7602 47.2463 50.7696 47.6565C50.779 48.0671 50.9563 48.4559 51.2598 48.7321C52.3694 49.8454 52.992 51.3531 52.992 52.9247C52.992 54.4964 52.3695 56.004 51.2598 57.1173L46.6099 61.7672C45.0917 63.1531 42.964 63.6537 40.9865 63.0913C39.0095 62.5284 37.4646 60.9819 36.9038 59.0044C36.3425 57.0268 36.8453 54.8997 38.2327 53.3824L40.5575 51.0576V51.057C41.0671 50.4622 41.0331 49.575 40.4791 49.0209C39.925 48.4669 39.0377 48.4324 38.4424 48.9425L36.1175 51.2673C34.4355 52.9346 33.4928 55.2067 33.5002 57.5746L33.5 57.5746Z"
      fill="black"
    />
    <path
      d="M59.4422 48.9432C58.9327 49.538 58.9667 50.4252 59.5207 50.9793C60.0747 51.5333 60.962 51.5678 61.5573 51.0578L63.8822 48.7329C65.5642 47.0656 66.5069 44.7935 66.4996 42.4257C66.4959 40.0594 65.5542 37.792 63.8811 36.119C62.2081 34.4459 59.9407 33.5043 57.5744 33.5005C55.2066 33.4932 52.9345 34.4359 51.2672 36.1179L46.6174 40.7678H46.6168C44.9417 42.4392 44 44.7087 44 47.0755C44 49.4423 44.9417 51.7112 46.6168 53.3833C47.2022 53.9645 48.1471 53.9645 48.732 53.3833C49.3137 52.7979 49.3137 51.853 48.732 51.2682C47.6229 50.1549 46.9997 48.6472 46.9997 47.0755C46.9997 45.5039 47.6228 43.9962 48.732 42.8829L53.3818 38.233H53.3823C54.8959 36.8185 57.0377 36.2963 59.0325 36.855C61.0274 37.4138 62.5863 38.9727 63.1451 40.9676C63.7038 42.9624 63.1817 45.1042 61.7671 46.6178L59.4422 48.9432Z"
      fill="black"
    />
  </svg>
);

export const Users = () => (
  <svg
    width="100"
    height="100"
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M49.9988 92.6314C73.5437 92.6314 92.6303 73.7804 92.6303 50.5262C92.6303 27.2719 73.5437 8.4209 49.9988 8.4209C26.4538 8.4209 7.36719 27.2719 7.36719 50.5262C7.36719 73.7804 26.4538 92.6314 49.9988 92.6314ZM49.9988 89.5877C28.156 89.5877 10.449 72.0993 10.449 50.5262C10.449 28.953 28.156 11.4647 49.9988 11.4647C71.8415 11.4647 89.5485 28.953 89.5485 50.5262C89.5485 72.0993 71.8415 89.5877 49.9988 89.5877Z"
      fill="black"
    />
    <path
      d="M50.4967 31C55.9371 31 60.3622 35.4247 60.3622 40.8655C60.3622 44.3268 58.5763 47.3727 55.8752 49.1335C58.668 50.143 61.1172 51.9276 62.9504 54.2659C63.3881 54.8259 63.2877 55.637 62.7277 56.0748C62.1677 56.5126 61.3566 56.4121 60.9188 55.8521C58.406 52.6453 54.5693 50.7821 50.497 50.7821C46.426 50.7821 42.5906 52.6471 40.0778 55.851C39.64 56.411 38.8289 56.5118 38.2689 56.0736C37.7089 55.6358 37.608 54.8248 38.0462 54.2647C39.8832 51.9214 42.326 50.1468 45.1214 49.1335C42.4202 47.372 40.6331 44.3242 40.6331 40.8655C40.6331 35.4263 45.0578 31 50.4973 31H50.4967ZM50.4967 33.5865C46.4705 33.5865 43.2193 36.8389 43.2193 40.8652C43.2193 44.8901 46.4717 48.1426 50.4967 48.1426C54.5216 48.1426 57.7753 44.8902 57.7753 40.8652C57.7753 36.8377 54.5242 33.5865 50.4967 33.5865Z"
      fill="black"
    />
    <path
      d="M28.1583 38.1006C33.5987 38.1006 38.0238 42.5253 38.0238 47.9661C38.0238 51.2963 36.3484 54.3742 33.5837 56.201C38.1954 57.8864 41.7981 61.6557 43.2608 66.3566C43.4722 67.0363 43.093 67.762 42.4129 67.9733C41.7332 68.1847 41.0075 67.8055 40.7961 67.1254C39.0752 61.5946 33.949 57.8303 28.1597 57.8303C22.3689 57.8303 17.2439 61.5933 15.5232 67.1254C15.3118 67.8051 14.5861 68.1847 13.9064 67.9733C13.2267 67.762 12.8471 67.0363 13.0585 66.3566C14.5212 61.6581 18.1234 57.8852 22.7345 56.201C19.9696 54.3704 18.2943 51.3001 18.2943 47.9661C18.2943 42.5269 22.719 38.1006 28.1586 38.1006H28.1583ZM28.1583 40.6871C24.1321 40.6871 20.8809 43.9395 20.8809 47.9658C20.8809 51.9921 24.1332 55.2431 28.1596 55.2431C32.1845 55.2431 35.4369 51.9908 35.4369 47.9658C35.4369 43.9396 32.1846 40.6871 28.1583 40.6871Z"
      fill="black"
    />
    <path
      d="M72.839 38.1006C78.2794 38.1006 82.7045 42.5253 82.7045 47.9661C82.7045 51.3014 81.0304 54.3692 78.2644 56.201C82.8775 57.8902 86.4789 61.6494 87.9416 66.3566C88.1529 67.0363 87.7738 67.762 87.0936 67.9733C86.414 68.1847 85.6882 67.8055 85.4769 67.1254C83.7584 61.5933 78.6285 57.8303 72.8404 57.8303C67.0522 57.8303 61.9215 61.5946 60.2029 67.1254C59.9915 67.8051 59.2658 68.1847 58.5861 67.9733C57.9064 67.762 57.5268 67.0363 57.7382 66.3566C59.1984 61.6557 62.802 57.8889 67.4111 56.2023C64.6476 54.3716 62.9748 51.2976 62.9748 47.9661C62.9748 42.5257 67.3969 38.1006 72.839 38.1006H72.839ZM72.839 40.6871C68.8178 40.6871 65.5617 43.9433 65.5617 47.9658C65.5617 51.9907 68.8153 55.2431 72.839 55.2431C76.8652 55.2431 80.1177 51.992 80.1177 47.9658C80.1177 43.9383 76.8665 40.6871 72.839 40.6871Z"
      fill="black"
    />
  </svg>
);
